const widgetDiv = document.getElementById('openchair-widget');

export const setPrimaryColors = (el) => {
  const primaryColor = widgetDiv.dataset.primarycolor;
  if (primaryColor) { el.style.background = primaryColor; }
  return el;
};

export const setPrimaryFontColor = (el) => {
  const primaryFontColor = widgetDiv.dataset.primarycolortext;
  if (primaryFontColor) { el.style.color = primaryFontColor; }
  return el;
};

export const getThemeClass = () => {
  const theme = widgetDiv.dataset.theme;
  return theme === 'dark' ?
    'openChair__darkTheme' :
    'openChair__lightTheme';
};

const setBorder = (daySelector, secondaryColor) => {
  const allElements = document.getElementsByClassName(daySelector);
  Array.from(allElements).forEach((node) => {
    node.style.borderColor = secondaryColor;
  });
};

const setFontColor = (el) => {
  const secondaryFontColor = widgetDiv.dataset.secondarycolortext;
  el.style.color = secondaryFontColor;
};

export const setSecondaryColor = (el, daySelector) => {
  const secondaryColor = widgetDiv.dataset.secondarycolor;

  if (secondaryColor) {
    el.style.background = secondaryColor;
    setFontColor(el);
    setBorder(daySelector, secondaryColor);
  }
};

export const hideMainButton = () => !!widgetDiv.dataset.hidebutton;



// WEBPACK FOOTER //
// ./src/helpers/setColors.js